import React, { FC, useContext } from 'react'
import { Typography, ScreenContext } from 'react-components'
import { FormattedCustomerObjectsTransport } from '../../../models/property-details-page/customer-objects-model'
import { ComponentSeparator, ExposeSectionTitleWrapper } from '../styles'
import { useTranslation } from '../../../hooks/locale'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import ExternalLink from '../../common/external-link'
import { CustomerObjectsSectionWrapper, ImageWrapper, SliderContainer } from './styles'
import { FormattedContactDetails } from '../../../models/property-details-page/contact-model'
import ImageLoadingComponent from '../../app-components/image-loading-component'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { EmblaCarousel } from '../../common/embla-carousel'

type CustomerObjectsSectionProps = {
    customerObjects: FormattedCustomerObjectsTransport | null
    contact: FormattedContactDetails | null
    bookingType: FormattedBookingTypeData | null
}

const CustomerObjectsSection: FC<CustomerObjectsSectionProps> = ({ customerObjects, contact, bookingType }) => {
    const { t } = useTranslation()
    const { isDesktop } = useContext(ScreenContext)

    const objects = get(customerObjects, 'objects', [])
    const objectOverviewLink = get(customerObjects, 'objectOverviewLink', '')
    const isHMSObject = get(contact, 'isHMSObject', false)
    const isDirectBooking = get(bookingType, 'type') === 'direct_booking' && isEmpty(get(bookingType, 'subType.type'))
    const customerObjectsSectionGenericTitle = t('accomodations.customerObjectsSectionGenericTitle')

    if (isEmpty(objects) || isHMSObject) {
        return null
    }

    const slides = objects
        .map((custObject: any, index: number) => {
            const imageUrl = get(custObject, 'imageUrl', '')
            const exposeUrl = get(custObject, 'exposeUrl', '')
            const title = get(custObject, 'title')

            if (!imageUrl) {
                return null
            }
            return (
                <ExternalLink as="a" href={exposeUrl} key={`${title}_${index}`}>
                    <ImageWrapper>
                        <ImageLoadingComponent src={imageUrl} alt={title} borderRadius="8px" />
                    </ImageWrapper>
                </ExternalLink>
            )
        })
        .filter(Boolean) as React.ReactNode[]

    return (
        <>
            <CustomerObjectsSectionWrapper>
                <ExposeSectionTitleWrapper>
                    <Typography variant="h6" fontWeight="semiBold" element="h2">
                        {t('accomodations.customerObjectsSectionTitle')}
                    </Typography>
                </ExposeSectionTitleWrapper>
                <SliderContainer>
                    <Typography variant="subtitle1" fontWeight="regular">
                        {t('accomodations.customerObjectsTitle', {
                            name: isDirectBooking ? customerObjectsSectionGenericTitle : get(contact, 'name', ''),
                        })}
                    </Typography>
                    <EmblaCarousel
                        slides={slides}
                        visibleSlides={isDesktop ? 3 : 1}
                        slidesToScroll={1}
                        loop={false}
                        showNav
                        navVariant="dark-overlay"
                    />
                    {objectOverviewLink && (
                        <ExternalLink as="a" href={objectOverviewLink}>
                            <Typography variant="subtitle2" fontWeight="regular" textDecoration="underline">
                                {t('accomodations.showAllAccomodations')}
                            </Typography>
                        </ExternalLink>
                    )}
                </SliderContainer>
            </CustomerObjectsSectionWrapper>
            <ComponentSeparator />
        </>
    )
}

export default CustomerObjectsSection
